<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BASIC
                    SCIENCES &
                    BIO-TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Chemistry</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Post Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Master of Science(Chemistry)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Chemistry</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Science (Chemistry)</b>
                    – The MSc in Chemistry, a two-year postgraduate program offered by the ARNI School of Basic
                    Scientific & Bio-Technology, explores the basic scientific concept of chemistry in great detail. A
                    combination of academic lectures, individual and group projects, practical reports, and professional
                    training make up an MSc in Chemistry. Quantum chemistry, surface chemistry, thermodynamics, and
                    other topics are covered in the MSc Chemistry program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Inorganic Chains, Rings, and Clusters</li>
                    <li> Stereochemistry and Reaction Mechanism</li>
                    <li> Transition and Non-transition Metal Chemistry</li>
                    <li> Principles of Organic Chemistry</li>
                    <li> Group Theory and Quantum Chemistry</li>
                    <li> Physical Chemistry Experiments Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Thermodynamics and Equilibria</li>
                    <li> Solid State Chemistry and Materials Science</li>
                    <li> Chemical Dynamics and Electrochemistry</li>
                    <li> Organic Reactions Mechanisms</li>
                    <li> Inorganic Quantitative Analysis Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Spectroscopic Identification of Molecules</li>
                    <li> Bioinorganic and Organometallic Chemistry</li>
                    <li> Medicinal Chemistry</li>
                    <li> Modern Techniques and Scope of Chemical Biology</li>
                    <li> Classical and Statistical Thermodynamics</li>
                    <li> Physical Chemistry Laboratory</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Computer in Chemistry</li>
                    <li> Industrial Catalysis</li>
                    <li> Polymer Science</li>
                    <li> Electro Analytics and Radio Analytics</li>
                    <li> Elective I</li>
                </ul>
            </div>

        </div>

    </div>
</section>
